import * as React from "react";
import Modal from "../../ui/modal/Modal";
import TextArea from "../../../hiberUiKit/src/atoms/TextArea/TextArea";
import FormButtonsView from "../../ui/form/FormButtonsView";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";

interface IComponentProps {
	/**
	 * Close modal callback.
	 */
	onClose: () => void;
	/**
	 * On add action callback
	 * @param {string} eventMessage
	 */
	onAdd: (eventMessage: string) => void
}

interface IState {
	/**
	 * Message.
	 */
	eventMessage: string;
}

type Props = IComponentProps

export default class AddEventModal extends React.PureComponent<Props, IState> {

	constructor(props: Props) {
		super(props);
		this.state = {eventMessage: ""};
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose}
				   title={"Add event"}>
				<TextArea onChange={(e) => {this.setState({eventMessage: e.target.value})}}
						  hasBorder={true}
						  value={this.state.eventMessage}
						  placeholder={"Message text"}
						  focus
						  rows={5}/>
				<FormButtonsView align={"right"}>
					<div style={{paddingTop: "20px"}}>
						<div className="pull-left">
							<ButtonTertiary label="Cancel"
											onClick={this.props.onClose}/>
						</div>
						<ButtonPrimary label={"Add event"}
									   onClick={() => this.props.onAdd(this.state.eventMessage.trim())}
									   disabled={!(this.state.eventMessage.trim().length)}/>
					</div>
				</FormButtonsView>
			</Modal>
		)
	}

}
